export function ClearIcon(props) {
	return (
		<svg viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				d="M9.5 4.5L4.5 9.5M4.5 4.5L9.5 9.5"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
